module.exports = __webpack_public_path__ + "img/ABL-ESD-GoDetect-ESD-min.49794c86.png";